import React from "react";
import { gql } from "graphql-tag";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader } from "@mui/material";
import { useMutation } from "@apollo/client";
import { createForm as createFormType, createFormVariables, FormType } from "types/gql-types";
import { useSnackbar } from "components/haven-design/snackbar";
import logger from "services/logger";
import DefinitionsForm, { FormDefinition as Definition } from "./form";
import { SubmitFormResult } from "./form-definition-actions";
import contentTemplate from "./template";
import { validateContent } from "./toml-validator";

const CREATE_FORM = gql`
  mutation createForm($data: FormDefinitionInput!) {
    createFormDefinition(data: $data) {
      name
      content
      propertyId
      enabled
      createInterest
      formType
      skipSignature
      renderParagraphs
      ageRequirement
      ageRequirementOrDisabilityOverride
    }
  }
`;

const initialData = {
  id: null,
  name: "",
  content: contentTemplate,
  propertyId: "",
  enabled: false,
  createInterest: false,
  formType: FormType.PRE_APPLICATION,
  skipSignature: false,
  renderParagraphs: false,
  ageRequirement: 18,
  ageRequirementOrDisabilityOverride: false,
  form: null,
  formId: null,
};

const NewDefinition: React.FC = () => {
  const navigate = useNavigate();
  const { openSnackbar } = useSnackbar();
  const [createForm] = useMutation<
  createFormType,
  createFormVariables
  >(CREATE_FORM);

  const submitForm = async (formData: Definition): Promise<SubmitFormResult> => {
    if (formData.enabled && validateContent(formData.content).length > 0) {
      openSnackbar({ message: "Insert failed, TOML invalid", status: "error" });
      return { saved: false };
    }

    try {
      const { id: _id, form: _form, formId: _formId, ...filteredData } = formData;
      await createForm({ variables: { data: filteredData } });
      navigate("/dash/admin/forms");
      return { saved: true };
    } catch (err) {
      logger.sendError(err as Error);
      throw err;
    }
  };

  return (
    <Card>
      <CardHeader title="Create a Form Draft" subheader="Required fields marked with *" />
      <DefinitionsForm
        formType="new"
        initialData={initialData}
        handleSubmit={submitForm}
      />
    </Card>
  );
};

export default NewDefinition;
